<div class="title-description">{{ details?.securityCode ?? 'Unknown' }} off market buyback</div>

<app-infobox-table [data]="computeInfoboxEntries()!"></app-infobox-table>

<app-blue-label>Note: Components are shown in dollars per unit</app-blue-label>

<app-components-table [data]="details"></app-components-table>
